module.exports = __webpack_public_path__ + "img/falls-goal-slide2.6e30468b.gif";